import React, { useState } from 'react'
import CallServiceTable from '../../components/Tables/CallServiceTable';
import { Button } from '../../components/Buttons';
import { useDialog } from '../../contexts/DialogContext';
import { DialogConfirmation } from '../../components/Modal';
import { H3 } from '../../components/Text';
import FormDefault from '../../components/Forms/FormDefault';
import * as Yup from "yup";
import { requestAuth } from '../../components/services/RequestService';
import { toast } from 'react-toastify';
import { useModal } from '../../contexts/ModalContext';
import SendAnnouncement from './SendAnnouncement';

const Announcement = () => {
  const [reload, setReload] = useState(false);

  const { openDialog, dialogClose } = useDialog();
  const { openModal } = useModal();

  async function onSubmit(values) {
    console.log(values)
    await requestAuth(
      values.isUpdate ? "put" : "post",
      `/announcement`,
      values
    )
      .then(() => {
        setReload(x => !x);
        dialogClose();
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  function createData(data, isUpdate = false) {
    openDialog(
      <div className='mb-5 w-auto md:min-w-[480px] lg:min-w-[580px] xl:min-w-[800px]'>
        <FormDefault
          tittle={isUpdate ? "EDITAR BOLETIN INFORMATIVO" : "ADICIONAR BOLETIN INFORMATIVO"}
          fields={[
            {
              label: "N° de referencia",
              name: "title",
            },
            {
              label: "Asunto",
              name: "subject",
              validate: true,
              // aditionalClassName: 'w-full'
            },
            {
              label: "Contenido",
              name: "content",
              type: "textArea",
              rows: 5
            },
            {
              label: "Fecha de inicio",
              name: "startDate",
              placeholder: "",
              type: "date",
              typeInput: "date",
            },
            {
              label: "Fecha de vigencia",
              name: "effectiveDate",
              placeholder: "",
              type: "date",
              typeInput: "date",
            },
          ]}
          initialValues={{
            number: data?.number ?? '',
            title: data?.title ?? '',
            subject: data?.subject ?? '',
            content: data?.content ?? '',
            startDate: data?.startDate?.split("T")[0] ?? '',
            effectiveDate: data?.effectiveDate?.split("T")[0] ?? '',
            id: data?.id ?? '',
            isUpdate: isUpdate,
          }}
          validationSchema={Yup.object().shape({
            subject: Yup.mixed().required("Campo requerido.").nullable(),
          })}
          onSubmit={(values) =>
            onSubmit({ ...values, name: data?.name })
          }
          buttonName="Registrar"
        />
      </div>
    );
  }

  function updateData(data) {
    createData(data, true)
  }

  function handleDelete(circular) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el tramite?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/announcement/${circular.id}`}
        texBtn="Eliminar"
        handleSuccess={() => setReload(x => !x)}
      />
    );
  }

  function handleSend(data) {
    openModal(
      <SendAnnouncement
        data={data}
      />
    );
  }

  return (
    <>
      <CallServiceTable
        reload={reload}
        component={({ reload }) => {
          return (
            <>
              <Button
                position="left"
                content="CREAR BOLETIN INFORMATIVO"
                onClick={() => createData()}
              >
                <i className="far fa-file"></i>
              </Button>
            </>
          );
        }}
        addFilters={[
          {
            name: "title",
            label: "Título",
            filter: true,
          }
        ]}
        urlApi="/announcement"
        filters={[
        ]}
        header={[
          { name: "title", label: "N° de referencia" },
          { name: "startDate", label: "Fecha de inicio", type: 'date', dateFormat:"DD/MM/YYYY" },
          { name: "effectiveDate", label: "Fecha de vigencia", type: 'date', dateFormat:"DD/MM/YYYY" },
          { name: "content", label: "Contenido" },
          { name: "subject", label: "Asunto", },
          {
            name: "manage",
            type: "action",
            label: "Gestionar",
            sticky: true,
            actions: [
              {
                label: "Editar",
                icon: "fas fa-edit",
                action: updateData,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Eliminar",
                icon: "fas fa-trash",
                action: handleDelete,
                color: "text-[#ff2d55]",
              },
            ],
          },
        ]}
        onClick={(a) => handleSend(a)}
      />
    </>
  )
}

export default Announcement